/**
 * lazy — code-splitting boundary for the ECharts dependency.
 *
 * The `echarts` + `echarts-for-react` pair weighs ~120 KB gzipped — same
 * order of magnitude as Tiptap. We don't want that to load on routes that
 * never render a chart (every workspace page, settings, admin, etc.).
 *
 * The strategy mirrors `ando/composer-parts/RichTextEditorLazy.tsx`:
 *   - `React.lazy()` around the heavy inner component
 *   - the wrapper renders a `<Suspense>` around it with a Skeleton fallback
 *
 * The fallback intentionally matches the resting chrome of the chart card
 * (full-width pulsing rectangle) so the layout doesn't reflow when the
 * chunk arrives.
 */

import * as React from "react";

/**
 * Inner ECharts component. Defaulted as `{ default: ChartImpl }` so
 * `React.lazy()` consumes the module shape it expects.
 */
export const ChartImplLazy = React.lazy(() => import("./ChartImpl.js"));
